import { Alert, Box, Button } from "@mui/material";
import React from "react";
import CustomTabs from "../../widgets/CustomTabs";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import RdCampaignImport from "./contacts/RdCampaignImport";
import HighlightIcon from "@mui/icons-material/Highlight";
import RdCampaignContactGoup from "./contacts/RdCampaignContactGoup";
import RdCampaignQuickContacts from "./contacts/RdCampaignQuickContacts";
import RdMarketingGroup from "./contacts/RdMarketingGroup";
const RdCampaignStep2 = ({
  campaignPost,
  setCampaignPost,
  setActiveStep,
  contactGroup,
  setContactGroup,
  contactGroupName,
  contactsType,
}) => {
  if (!campaignPost.campaignName || !campaignPost.template) {
    return (
      <Alert severity="warning">
        Please select mention campaign name and select template.
        <Button
          onClick={() => {
            setActiveStep(0);
          }}
          variant="outlined"
          sx={{ ml: 2 }}
        >
          Go back
        </Button>
      </Alert>
    );
  }
  const tabsData =
    contactGroupName && contactGroupName.trim() !== ""
      ? [
          contactsType === "database"
            ? {
                label: "Marketing",
                icon: (
                  <HighlightIcon
                    fontSize="small"
                    sx={{ transition: "all 0.3s" }}
                  />
                ),
              }
            : {
                label: "Contact Group",
                icon: (
                  <ContactPhoneIcon
                    fontSize="small"
                    sx={{ transition: "all 0.3s" }}
                  />
                ),
              },
        ]
      : [
          {
            label: "Excel Import",
            icon: (
              <ImportExportIcon
                fontSize="small"
                sx={{ transition: "all 0.3s" }}
              />
            ),
          },
          {
            label: "Contact Group",
            icon: (
              <ContactPhoneIcon
                fontSize="small"
                sx={{ transition: "all 0.3s" }}
              />
            ),
          },
          {
            label: "Marketing",
            icon: (
              <HighlightIcon fontSize="small" sx={{ transition: "all 0.3s" }} />
            ),
          },
          {
            label: "Quick Contacts",
            icon: (
              <PhoneForwardedIcon
                fontSize="small"
                sx={{ transition: "all 0.3s" }}
              />
            ),
          },
        ];
  return (
    <Box>
      <CustomTabs
        tabs={tabsData}
        value={contactGroup}
        onChange={(e, newValue) => {
          setCampaignPost((prev) => ({ ...prev, contacts: [] }));
          setContactGroup(newValue);
        }}
        containerSx={{ width: "100%", my: 1 }}
      />
      {contactGroup === 0 && (
        <RdCampaignImport
          campaignPost={campaignPost}
          setCampaignPost={setCampaignPost}
          setActiveStep={setActiveStep}
          contactGroup={contactGroup}
        />
      )}
      {contactGroup === 1 && (
        <RdCampaignContactGoup
          campaignPost={campaignPost}
          setCampaignPost={setCampaignPost}
          setActiveStep={setActiveStep}
          contactGroup={contactGroup}
          groupName={contactGroupName}
        />
      )}
      {contactGroup === 2 && (
        <RdMarketingGroup
          campaignPost={campaignPost}
          setCampaignPost={setCampaignPost}
          setActiveStep={setActiveStep}
          contactGroup={contactGroup}
          groupName={contactGroupName}
        />
      )}
      {contactGroup === 3 && (
        <RdCampaignQuickContacts
          campaignPost={campaignPost}
          setCampaignPost={setCampaignPost}
          setActiveStep={setActiveStep}
          contactGroup={contactGroup}
        />
      )}
    </Box>
  );
};

export default RdCampaignStep2;
